import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Colors from '../../../../../../constants/Colors';
import RightPointer from '../../../../../30pxIcons/RightPointer';
import PressableStyled from '../../../../../PressableStyled';

// eslint-disable-next-line no-unused-vars, no-shadow
export enum TemplateUpdateOption { DEFAULT = 1, CUSTOM, VARIANT, EDIT }

interface CreationOptionProps {
  onPress: () => void,
  title: string,
  description: string,
  testID?: string,
}

const CreationOption = ({
  onPress, title, description, testID,
}: CreationOptionProps) => <PressableStyled
  {...{ onPress, testID }}
  style={styles.container}
>
    <View style={styles.content}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.description}>
        {description}
      </Text>
    </View>
    <RightPointer />
  </PressableStyled>;

const styles = StyleSheet.create({
  container: {
    paddingVertical: 16,
    paddingHorizontal: 12,
    borderRadius: 5,
    backgroundColor: Colors.light.hereworksWhite200,
    borderColor: Colors.light.hereworksBlue100,
    borderWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  content: {
    flex: 1,
    marginEnd: 8,
    maxWidth: '90%',
  },
  title: {
    fontSize: 20,
    lineHeight: 30,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
  },
  description: {
    fontSize: 16,
    lineHeight: 19,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
  },
});

export default CreationOption;
